import {get,post} from "@/utils/axios";

const getOrderInfo = p => get("/api-seller/apiseller/goods/getOrderInfo", p);

const getOrderPassword = p => get("/api-seller/apiConsoleGoods/getOrderPassword", p);

export default {
    getOrderInfo,
    getOrderPassword
}